import React, {useEffect, useState} from "react";
import { Input,Table,Switch,Layout, message, Card, Col, Row, ConfigProvider, Pagination, Tabs, Button, Tag } from 'antd';
import courseTeacherMenuStyles from "./menu.module.less";

import zhCN from 'antd/lib/locale/zh_CN'
import * as constants from '../../../constants/constants';

import LoginRegisterModal from "../../../component/modal/login-register/login-register";
import {checkUserLogin} from "../../common/user-center/user-info";
import { ClockCircleOutlined,VideoCameraOutlined,CodeOutlined,FormOutlined,UserOutlined } from '@ant-design/icons';

export interface Props {
    init_menu:any;
}

       
export const test_menu = { //课程大纲
    id: 2,
    name: "数据科学导引",
    directory: [
        {id:1, name:"数据科学介绍" , 
        summary: '本章带大家极速入门数据科学，主要包括：1.数据科学概述；2.数据科学的基本内容；3.数据科学的行业应用；1.数据科学概述；2.数据科学的基本内容；3.数据科学的行业应用；1.数据科学概述；2.数据科学的基本内容；3.数据科学的行业应用；',
        modules:[
            {id:12,name:'数据科学概述'},
            {id:13,name:'数据科学的基本内容'},
            {id:14,name:'数据科学的行业应用'}]},
        {id:2, name: "数据预处理" , 
        summary: '本章带大家极速入门数据科学，主要包括：1.数据科学概述；2.数据科学的基本内容；3.数据科学的行业应用；',
        modules:[
            {id:15,name:'数据诊断与探索'},
            {id:16,name:'缺失值处理'},
            {id:17,name:'离群值处理'},
            {id: 18,name: "特征编码"}]},
        {id:3, name:"回归" ,  
        summary: '本章带大家极速入门数据科学，主要包括：1.数据科学概述；2.数据科学的基本内容；3.数据科学的行业应用；',
        modules:[
            {id:19,name:'简单线性回归'},
            {id:20,name:'岭回归和LASSO'}]},
        {id:4, name:"分类" ,  
        summary: '本章带大家极速入门数据科学，主要包括：1.数据科学概述；2.数据科学的基本内容；3.数据科学的行业应用；',
        modules:[
            {id:21,name:'分类问题介绍'},
            {id:22,name:'逻辑回归'},
            {id:23,name:'K近邻'},
            {id:24,name:'决策树'},
            {id:25,name:'朴素贝叶斯'}]},
        {id:5, name:"集成方法" , 
        summary: '本章带大家极速入门数据科学，主要包括：1.数据科学概述；2.数据科学的基本内容；3.数据科学的行业应用；',
         modules:[
            {id:26,name:'集成方法介绍'},
            {id:27,name:'随机森林'},
            {id:28,name:'AdaBoost'}]},
        {id:6, name:"聚类" ,  
        summary: '本章带大家极速入门数据科学，主要包括：1.数据科学概述；2.数据科学的基本内容；3.数据科学的行业应用；',
        modules:[
            {id:29,name:'聚类问题介绍'},
            {id:30,name:'K-Means聚类'},
            {id:31,name:'层次聚类'}]},
        {id:7, name:"降维" ,  
        summary: '本章带大家极速入门数据科学，主要包括：1.数据科学概述；2.数据科学的基本内容；3.数据科学的行业应用；',
        modules:[
            {id:32,name:'降维介绍'},
            {id:33,name:'主成分分析'}]}
    ],
    createTime: "2021-7-18",
    modifyTime: "2021-9-20",
    user: "jiatian",
    status: 1,
}


/** 教师课程大纲标签页 */
export const MenuPreview: React.FC<Props> = (props) => {
    const {init_menu} = props
    const [menu,setMenu] = useState(init_menu)

    useEffect(()=> {
        // 示例代码请勿删除
  /*      sendHttpPostRequest(
            'case/api/get_case_list',
            {page: 1, pagesize: 16, type: 1, query: ""},
            renderCourse
        );*/
  },[])

    return (
        <div className={courseTeacherMenuStyles.tabpaneWrapper}>
        {
            menu.directory?.map((chapter, chapterInd)=>(
            <div key={"chapter" + chapter.id}>
                <div className={courseTeacherMenuStyles.chapterName} style={{textAlign:'left',fontWeight: 700}} > { "第" +  (chapterInd + 1)  + "章 " + chapter.name}</div>
                <div className={courseTeacherMenuStyles.chapterSummary} style={{marginTop:5,marginBottom:18,fontSize:10,color:'#ccc',textAlign:'left'}}>{chapter.summary}</div>
                {chapter.modules.map((module, moduleIndex) => (
                <div key={module.id} className={courseTeacherMenuStyles.modules} >
                    <Row  gutter={[4, 4]} justify='start' align='middle'>
                        <Col flex='30px'> <div className={courseTeacherMenuStyles.timeperiod} style={{paddingLeft:5,paddingRight:5,marginLeft:5,fontSize:12,borderRadius:5}}>15:00</div></Col>
                        <Col style={{textAlign:'left'}} flex="auto"> {(chapterInd + 1) + "-" + (moduleIndex+1) + " " + module.name}</Col>
                                    
                        <Col flex="100px">  
                            <CodeOutlined className={courseTeacherMenuStyles.iconbuttons}/>
                            <FormOutlined className={courseTeacherMenuStyles.iconbuttons}/>
                            <VideoCameraOutlined className={courseTeacherMenuStyles.iconbuttons}/>
                        </Col>

                    </Row>  
                </div>
                ))}

            </div>))                 
         }
        </div>
    )

}

export default MenuPreview

